import React, { useCallback, useMemo } from 'react';
import { OrderProduct } from './OrderProduct';
import { isEmpty } from "lodash";
import IMG from "../../constants/image";
import ImageBasic from "../Common/Image/ImageBasic";
import { clsx } from "clsx";
import OrderSummary from "./OrderSummary";
import { LOCAL_STORAGE_KEY, PATH, STATUS_ORDERS } from "../../constants";
import { formatDate } from "../../utils";
import { isMobile } from "react-device-detect";
import { useNavigate } from "react-router-dom";


export const OrderGroup = ({ group }) => {
    const navigate = useNavigate();
    const { orderItems, status, id, createdAt, shipping } = group || {}
    const { address, commune, district, phoneNumber, province, name } = shipping?.userAddr || {}

    const addressShip = !isEmpty(shipping?.userAddr) && `${address}, ${commune}, ${district}, ${province}`
    // Update the setter function
    const orderStatus = useMemo(() => {
        const isProcessing = group.status === 'shipping_processing';
        const isPending = ['seller_confirm', 'order_created', 'system_process', 'seller_processing', 'seller_prepared'].includes(group.status);
        const isDelivered = group.status === 'shipping_done' || group.status === 'order_complete';
        const isCancelled = group.status === 'order_cancel';
        const isReturned = group.status === 'order_refund';

        return { isProcessing, isPending, isDelivered, isCancelled, isReturned };
    }, [group.status]);

    const iconOrder = useMemo(() => {
        if (orderStatus.isPending) return IMG.icon.orderPending
        if (orderStatus.isDelivered) return IMG.icon.orderSuccess;
        if (orderStatus.isProcessing) return IMG.icon.cube;
        if (orderStatus.isCancelled) return IMG.icon.orderCancel;
        if (orderStatus.isReturned) return IMG.icon.orderReturned;
        return '';
    }, [orderStatus]);


    const handleDetailProduct = () => {
        if (!isEmpty(group)) {
            localStorage.setItem(LOCAL_STORAGE_KEY.ORDER_STORAGE_KEY, JSON.stringify(group));
            navigate(`${PATH.BUYER_MANAGEMENT_CART_DETAIL}?id=${id}`);
        }
    }

    const getStatusName = useCallback((statusValue) => {
        const statusObj = STATUS_ORDERS.find(item => item.value === statusValue);
        return statusObj ? statusObj.name : statusValue;
    }, []);

    return (
        <div className="rounded-lg mb-4 text-sm bg-white overflow-hidden">
            <div
                className="flex justify-between items-center bg-[#FFFCF3] py-[10px] px-4 md:p-4 border-b border-gray-200 md:cursor-pointer"
                onClick={handleDetailProduct}>
                <div className='flex items-center space-x-4'>
                    <div className='flex items-center'>
                        {
                            !isMobile && (
                                <ImageBasic className='w-5 h-5' src={IMG.icon.cube} />
                            )
                        }
                        <div className="max-w-[300px] line-clamp-2 pl-2">Mã đơn hàng: {id}</div>
                    </div>
                    <div className='hidden md:flex items-center'>
                        <ImageBasic className='w-5 h-5' src={IMG.icon.calendar} />
                        <div className="max-w-[220px] line-clamp-2 pl-2">Ngày đặt: {formatDate(createdAt)}</div>
                    </div>
                </div>
                <div
                    className={clsx('flex items-center text-xs space-x-2  px-2 md:px-4 py-1 rounded-2xl', orderStatus?.isCancelled ? 'bg-gray-200' : 'bg-[#E8F2EE]')}>
                    <ImageBasic className='w-[18px] h-[18px]' src={iconOrder} />
                    <div className="w-auto whitespace-nowrap">{getStatusName(status)}</div>
                </div>

            </div>
            <div className='md:hidden p-4 bg-[#FAFAFC]' onClick={handleDetailProduct}>
                <div className='flex items-center cursor-pointer'>
                    <ImageBasic className='w-5 h-5' src={IMG.icon.calendar} />
                    <div className="max-w-[220px] line-clamp-2 pl-2">Ngày đặt: {formatDate(createdAt)}</div>
                </div>
                <div className='text-sm space-y-3 mt-3'>
                    <div className='flex space-x-2 font-bold'>
                        <ImageBasic className='w-5 h-5' src={IMG.icon.location} />
                        <div>
                            <div>{`${name} `}<span className='font-normal'>{`- ${phoneNumber}`}</span></div>
                            <div className='text-xs text-gray-500 font-normal'>{addressShip}
                            </div>
                        </div>
                    </div>
                    {(!orderStatus?.isCancelled && !orderStatus?.isPending && !isEmpty(shipping?.trackingInfo)) &&
                        <div className='bg-white p-3 rounded-[5px] w-fit mt-2 border border-dashed border-gray-200'>
                            <div>Vận chuyển bởi: {shipping?.trackingInfo?.logisticsProvider}</div>
                            <div>Mã vận đơn: <span>{shipping?.trackingInfo?.trackingNumber}</span>
                            </div>
                        </div>
                    }
                    {(orderStatus?.isCancelled && shipping?.userAddr?.noted) &&
                        <div className='hidden md:flex space-x-2'>
                            <ImageBasic className='w-5 h-5' src={IMG.icon.errorOutlineBlack} />
                            <div className=' text-xs'>
                                <div>Lý do huỷ:</div>
                                <div className='text-gray-500'>{shipping?.userAddr?.noted || ''}</div>
                            </div>
                        </div>}
                </div>
            </div>
            <div className="">
                {(orderItems || []).map((product, index) => (
                    <OrderProduct onDetailProduct={handleDetailProduct}
                        key={`order-item-${product.id || index}`}
                        product={product} />
                ))}
            </div>
            <OrderSummary data={group} addressShip={addressShip} orderStatus={orderStatus} orderGroupId={group?.id} />
        </div>
    );
};